// extracted by mini-css-extract-plugin
export default {"modal-container":"modal-container_ddjCo","modal-content":"modal-content_nvzwX","modal-sub-title":"modal-sub-title_KnDGy","modal-highlight":"modal-highlight_ddmce"};